angular.module('shared').directive('gtm', function() {
  return {
    restrict: 'E',
    scope: {
      gtmId: '='
    },
    controller: ["$scope", "$sce", function($scope, $sce) {
      var content, ref;
      $scope.enabled = ((ref = window.DATA) != null ? ref.embed_pixels : void 0) && $scope.gtmId;
      $scope.getId = function() {
        var ref1;
        return (ref1 = $scope.gtmId) != null ? ref1.replace(/([^a-z0-9\-]+)/gi, '') : void 0;
      };
      content = `<script> (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','${$scope.getId()}'); </script>`;
      return $scope.content = $sce.trustAsHtml(content);
    }],
    template: '<div ng-if="enabled" ng-bind-html="content"></div>'
  };
});
